/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import './components.css';
import axios from 'axios';
import loading from '../assets/loading.gif';

export default function HomeContent() {
  const [blogs, setBlogs] = useState([]);
  const [oss, setOss] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let history = useHistory();

  useEffect(function () {
    axios
      .get('https://akulweb.herokuapp.com/get-blogs')
      .then((res) => {
        setIsLoading(false);
        setBlogs(res.data.reverse());
      })
      .catch((err) => console.log(err));
    axios
      .get('https://akulweb.herokuapp.com/get-oss')
      .then((res) => {
        setOss(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  if (!isLoading) {
    return (
      <div>
        <div class='mt-2'>
          {/* about */}
          <div class='home-item'>
            <h3 onClick={() => history.push('/about')}>about</h3>
            <p>
              I am a student, currently studying computer science engineering. I
              am a web and mobile app developer. I primarily work with
              Javascript.
            </p>
          </div>
          {/* blogs */}
          <div class='home-item'>
            <h3 className='mb-2' onClick={() => history.push('/blogs')}>
              blogs
            </h3>
            {blogs.slice(0, 2).map((blog) => (
              <div class='blog mt-1 mb-3' key={`${blog.serialId}-${blog.slug}`}>
                <Link
                  to={`/blogs/${blog.serialId}/${blog.slug}`}
                  className='link'
                >
                  <h5 class='mb-0'>{blog.title}</h5>
                </Link>
                <div class='blogs-tags'>
                  {blog.tags.map((tag) => (
                    <small class='blog-tag mr-2'>{tag}</small>
                  ))}
                </div>
                <small>{blog.dateCreated}</small>
                <p class='mt-2 mb-0'>{blog.description}</p>
              </div>
            ))}
          </div>
          {/* oss */}
          <div className='home-item'>
            <h3>oss</h3>
            {oss
              .reverse()
              .slice()
              .map((ossProject) => (
                <div className='oss-item'>
                  <a href={ossProject.link}>
                    <h5>{ossProject.title}</h5>
                  </a>
                  <div className='blogs-tags'>
                    {ossProject.tags.map((tag) => (
                      <small class='blog-tag mr-2'>{tag}</small>
                    ))}
                  </div>
                  <p class='mt-2'>{ossProject.description}</p>
                </div>
              ))}
          </div>
          {/* projects */}
          <div onClick={() => history.push('/projects')} class='home-item mt-3'>
            <h3>projects</h3>
            <p class='mb-1'>
              I love to learn new technologies and build projects, let it be
              mobile or web. I have build some projects which are available at
              my github, you can check them out.
            </p>
            <a href='https://github.com/akulsr0/'>Github</a> |{' '}
            <a href='https://play.google.com/store/apps/developer?id=Akul+Srivastava'>
              Google Play
            </a>
          </div>
          {/* have a question */}
          <div onClick={() => history.push('/ask')} class='home-item mt-3'>
            <h3>have a question</h3>
            <p>
              I am easily reachable on my social media accounts mentioned in the
              footer, in case you have a question for me you can ask at my
              Instagram handle (@akulsr0) as I am mostly active there.
            </p>
          </div>
          <hr />
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <div class='mt-2'>
          {/* about */}
          <div class='home-item'>
            <h3 onClick={() => history.push('/about')}>about</h3>
            <p>
              I am a student, currently studying computer science engineering. I
              am a web and mobile app developer. I primarily work with
              Javascript.
            </p>
          </div>
          {/* blogs */}
          <div class='home-item'>
            <h3 className='mb-2' onClick={() => history.push('/blogs')}>
              blogs
            </h3>
            <center>
              <img src={loading} alt='loading' className='loading' />
            </center>
          </div>
          {/* oss */}
          <div className='home-item'>
            <h3>oss</h3>
            {oss
              .reverse()
              .slice()
              .map((ossProject) => (
                <div className='oss-item'>
                  <a href={ossProject.link}>
                    <h5>{ossProject.title}</h5>
                  </a>
                  <div className='blogs-tags'>
                    {ossProject.tags.map((tag) => (
                      <small class='blog-tag mr-2'>{tag}</small>
                    ))}
                  </div>
                  <p class='mt-2'>{ossProject.description}</p>
                </div>
              ))}
          </div>
          {/* projects */}
          <div onClick={() => history.push('/projects')} class='home-item'>
            <h3>projects</h3>
            <p class='mb-1'>
              I love to learn new technologies and build projects, let it be
              mobile or web. I have build some projects which are available at
              my github, you can check them out.
            </p>
            <a href='https://github.com/akulsr0/'>Github</a> |{' '}
            <a href='https://play.google.com/store/apps/developer?id=Akul+Srivastava'>
              Google Play
            </a>
          </div>
          {/* have a question */}
          <div onClick={() => history.push('/ask')} class='home-item mt-3'>
            <h3>have a question</h3>
            <p>
              I am easily reachable on my social media accounts mentioned in the
              footer, in case you have a question for me you can ask at my
              Instagram handle (@akulsr0) as I am mostly active there.
            </p>
          </div>
          <hr />
        </div>
      </div>
    );
  }
}
